import React from 'react';
import { uniqueId } from '@epl/helpers';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { breakpoints } from '../ModalUpsell.styles';

const CEExpertSupportSVG = styled.svg`
  margin: ${rem(20)} auto ${rem(-10)};
  display: block;
  max-width: ${rem(130)};

  @media only screen and (min-width: ${breakpoints.mobile}) {
    margin: ${rem(2)} auto ${rem(-10)};
    max-width: ${`${rem(108)}`};
  }
`;

const CEExpertSupport = ({ className }) => {
  const uniqueIdSuffix = uniqueId('feature');

  return (
    <CEExpertSupportSVG className={className} viewBox="0 0 108 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Expert support icon</title>
      <g filter={`url(#a-${uniqueIdSuffix})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.923 27.6a2.83 2.83 0 0 0-2.83-2.83H17.906a2.83 2.83 0 0 0-2.83 2.83v22.87a2.83 2.83 0 0 0 2.83 2.83h6.86v4.513a1.415 1.415 0 0 0 2.072 1.254L37.832 53.3h52.26a2.83 2.83 0 0 0 2.83-2.831V27.6Z"
          fill="#fff"
        />
      </g>
      <g filter={`url(#b-${uniqueIdSuffix})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 2.83A2.83 2.83 0 0 1 10.83 0h86.34A2.83 2.83 0 0 1 100 2.83v27.758a2.83 2.83 0 0 1-2.83 2.83h-8.621v5.963a1.415 1.415 0 0 1-2.088 1.246l-13.353-7.208H10.83A2.83 2.83 0 0 1 8 30.588V2.831Z"
          fill={`url(#c-${uniqueIdSuffix})`}
        />
      </g>
      <defs>
        <filter
          id={`a-${uniqueIdSuffix}`}
          x="8"
          y="19.108"
          width="92"
          height="48.615"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1.415" />
          <feGaussianBlur stdDeviation="3.538" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1326_71365" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1326_71365" result="shape" />
        </filter>
        <filter
          id={`b-${uniqueIdSuffix}`}
          x=".923"
          y="0"
          width="106.154"
          height="54.953"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="7.077" />
          <feGaussianBlur stdDeviation="3.538" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1326_71365" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1326_71365" result="shape" />
        </filter>
        <linearGradient
          id={`c-${uniqueIdSuffix}`}
          x1="-85.294"
          y1="-17.603"
          x2="-59.363"
          y2="76.283"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D4F91" />
          <stop offset="1" stopColor="#426DA9" />
        </linearGradient>
      </defs>
    </CEExpertSupportSVG>
  );
};

CEExpertSupport.defaultProps = {
  className: undefined,
};

CEExpertSupport.propTypes = {
  className: PropTypes.string,
};

export default CEExpertSupport;
